import script from "./StakeConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakeConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./StakeConfirmation.vue?vue&type=style&index=0&id=a0634038&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0634038"]])

export default __exports__